<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="店铺id" prop="shopId" >
        <a-input v-model="form.shopId" placeholder="请输入店铺id" />
      </a-form-model-item>
      <a-form-model-item label="剧本id" prop="scriptId" >
        <a-input v-model="form.scriptId" placeholder="请输入剧本id" />
      </a-form-model-item>
      <a-form-model-item label="是否预约 0.否 1.是" prop="isReserve" >
        <a-input v-model="form.isReserve" placeholder="请输入是否预约 0.否 1.是" />
      </a-form-model-item>
      <a-form-model-item label="剧本排序" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入剧本排序" />
      </a-form-model-item>
      <a-form-model-item label="剧本价位" prop="prices" >
        <a-input v-model="form.prices" placeholder="请输入剧本价位" />
      </a-form-model-item>
      <a-form-model-item label="剧本再领一本价位" prop="orderPrices" >
        <a-input v-model="form.orderPrices" placeholder="请输入剧本再领一本价位" />
      </a-form-model-item>
      <a-form-model-item label="剧本预购X车价格" prop="preOrderPrices" >
        <a-input v-model="form.preOrderPrices" placeholder="请输入剧本预购X车价格" />
      </a-form-model-item>
      <a-form-model-item label="卷包折扣 [9,8.5] JSON数组" prop="volumePackageDiscount" >
        <a-input v-model="form.volumePackageDiscount" placeholder="请输入卷包折扣 [9,8.5] JSON数组" />
      </a-form-model-item>
      <a-form-model-item label="卷包优惠卷有效期 单位:天 默认365天" prop="couponPackPromoValidity" >
        <a-input v-model="form.couponPackPromoValidity" placeholder="请输入卷包优惠卷有效期 单位:天 默认365天" />
      </a-form-model-item>
      <a-form-model-item label="是否手动调价" prop="isManualPrice" >
        <a-input v-model="form.isManualPrice" placeholder="请输入是否手动调价" />
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记，1：删除，0：未删除，默认0" prop="isDeleted" >
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记，1：删除，0：未删除，默认0" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="乐观锁" prop="version" >
        <a-input v-model="form.version" placeholder="请输入乐观锁" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShop, addShop, updateShop } from '@/api/played/shop'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        shopId: null,
        scriptId: null,
        isReserve: null,
        sort: null,
        prices: null,
        orderPrices: null,
        preOrderPrices: null,
        volumePackageDiscount: null,
        couponPackPromoValidity: null,
        isManualPrice: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        shopId: [
          { required: true, message: '店铺id不能为空', trigger: 'blur' }
        ],
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        isReserve: [
          { required: true, message: '是否预约 0.否 1.是不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '剧本排序不能为空', trigger: 'blur' }
        ],
        prices: [
          { required: true, message: '剧本价位不能为空', trigger: 'blur' }
        ],
        orderPrices: [
          { required: true, message: '剧本再领一本价位不能为空', trigger: 'blur' }
        ],
        preOrderPrices: [
          { required: true, message: '剧本预购X车价格不能为空', trigger: 'blur' }
        ],
        volumePackageDiscount: [
          { required: true, message: '卷包折扣 [9,8.5] JSON数组不能为空', trigger: 'blur' }
        ],
        couponPackPromoValidity: [
          { required: true, message: '卷包优惠卷有效期 单位:天 默认365天不能为空', trigger: 'blur' }
        ],
        isManualPrice: [
          { required: true, message: '是否手动调价不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        scriptId: null,
        isReserve: null,
        sort: null,
        prices: null,
        orderPrices: null,
        preOrderPrices: null,
        volumePackageDiscount: null,
        couponPackPromoValidity: null,
        isManualPrice: null,
        createTime: null,
        updateTime: null,
        creator: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getShop(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateShop(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addShop(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
